// extracted by mini-css-extract-plugin
export default {"content":"Archive_content__O5Lk-","error":"Archive_error__G-rpF","loading":"Archive_loading__ccMXj"};